module["exports"] = [
  ""
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/nb_NO/address/state.js
 ** module id = 758
 ** module chunks = 0
 **/